// extracted by mini-css-extract-plugin
module.exports = {"search-box":"SimpleFormGroupLtr_search-box__H6RPj","search-input":"SimpleFormGroupLtr_search-input__3ZrMi","btn-submit":"SimpleFormGroupLtr_btn-submit__2svwm"};